import { H2, H3, P1 } from '../../../styles/FontStyles';
import {
  Box,
  Flexed,
  SectionSeparator,
  Select
} from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';

import { Button } from '../../../components/common/Button/Button';

import { IconBitcoinMinus, IconBitcoinPlus } from './KriptoTap.styled';
import { useState } from 'react';
import { Icon } from '../../../styles/Icons';
import { Mobile } from '../../../App';

export const KriptoTapBuy = ({
  kriptoTapPackage,
  handleSelectPackage
}: any) => {
  const [quantity, setQuantity] = useState(1);

  const handleIncrement = () => {
    setQuantity((prev) => prev + 1);
  };

  const handleDecrement = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  };

  return (
    <Box dark p='60px 80px' pSM='padding: 40px 40px'>
      <H3 color={colors.primary900} mb='22'>
        {kriptoTapPackage?.name}
      </H3>
      <Flexed center gap='30px' width='100%' rowSM>
        <Flexed width='40%' widthSM='100%'>
          <img src={kriptoTapPackage?.image} style={{ width: '100%' }} />
        </Flexed>
        <Flexed column gap='20px' width='60%' widthSM='100%'>
          <Flexed center gap='50px' rowSM>
            <Flexed column widthSM='100%'>
              <H3
                mb='10'
                style={{ fontWeight: 'normal' }}
                color={colors.bitcoin}>
                One Time Membership Fee
              </H3>
              <H2 color={colors.bitcoin}>${kriptoTapPackage?.price}</H2>
            </Flexed>

            {/* <Flexed column widthSM='100%'>
              <H3 mb='10' color={colors.bitcoin}>
                Quantity
              </H3>
              <Flexed center gap='30px' betweenSM>
                <Icon pointer onClick={handleDecrement}>
                  <IconBitcoinMinus />
                </Icon>
                <Flexed width='30px' justifyCenter>
                  <H2 color={colors.bitcoin}>{quantity}</H2>
                </Flexed>
                <Icon pointer onClick={handleIncrement}>
                  <IconBitcoinPlus />
                </Icon>
              </Flexed>
            </Flexed> */}
          </Flexed>
          <SectionSeparator />
          {/* <Flexed center gap='50px'>
            <Flexed width='50%' column>
              <P1 color={colors.bitcoin}>Purchase with</P1>
              <P1 color={colors.bitcoin}>Chain: BSC</P1>
            </Flexed>
            <Flexed width='50%'>
              <Select m='0'></Select>
            </Flexed>
          </Flexed> */}
        </Flexed>
      </Flexed>
      <Button
        mt='30'
        style={{ background: colors.bitcoin }}
        onClick={() => handleSelectPackage(kriptoTapPackage)}>
        Purchase Card
      </Button>
    </Box>
  );
};
